import { apiListQuery, apiQuery, createQueryKeys } from '@/shared/data';
import {
  getEnumValues,
  listTenantOptions,
  listBankOptions,
  getAudit,
  listCosifAccounts,
} from './reference.api';
const keys = createQueryKeys('reference');
export function enumQuery(name: string, size: number, search?: string) {
  const options = { size, search };
  return apiQuery(keys.custom('enum', name, options), ({ signal }) =>
    getEnumValues(name, options, signal),
  );
}
export function tenantOptionsQuery() {
  return apiQuery(keys.custom('options', 'tenant'), ({ signal }) => listTenantOptions(signal), {
    staleTime: 10 * 60_000,
  });
}
export function bankOptionsQuery(search?: string) {
  return apiListQuery(keys.custom('options', 'bank', { search }), ({ signal }) =>
    listBankOptions(search, signal),
  );
}
export function auditQuery(recordType: string, id: string, extra: { enabled?: boolean } = {}) {
  return apiQuery(
    keys.custom('audit', recordType, id, { size: 10 }),
    ({ signal }) => getAudit(recordType, id, signal),
    extra,
  );
}

/** Referência COSIF; o módulo decide se exige externalAccountId. */
export function cosifAccountsQuery(extra: { enabled?: boolean } = {}) {
  return apiQuery(
    keys.custom('cosif', { transactionType: 'Transfer' }),
    ({ signal }) => listCosifAccounts(signal),
    extra,
  );
}
